import { useEffect, useState } from "react";

// Define a type for the items in the fonts array
type Font = {
  name: string;
  url: string;
};

const useFontLoader = (fonts: Font[]) => {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    const loadFonts = async () => {
      try {
        for (let i = 0; i < fonts.length; i++) {
          if (!document.fonts.check(`normal 1px ${fonts[i].name}`)) {
            const font = new FontFace(fonts[i].name, `url(${fonts[i].url})`, {
              weight: "normal",
              style: "normal",
            });
            await font.load();
            document.fonts.add(font);
          }
        }
        setFontsLoaded(true);
      } catch (err) {
        console.error("Failed to load font", err);
      }
    };
    loadFonts();
  }, [fonts]);

  return fontsLoaded; // boolean
};

export default useFontLoader;
